import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import ClaimsContext from './ClaimsContext';
import ClaimsReducer from './ClaimsReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const ClaimsState = (props) => {
    const initialState = {
        getClaims: {
            claims: [],
            firstClaim: null,
            lastClaim: null,
            nextClaims: null,
            claimsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getClaimsAllMonth: {
            claims: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getClaimsById: {
            claim: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateClaimsById: {
            loading: false,
            hasSuccess: {
                type: null,
                success: false
            },
            hasError: {
                code: null,
                message: null
            }
        },
        getActionsClaims: {
            actionsClaims: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getClaimsExcel: {
            claims: [],
            claimsFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        }
    }

    const [state, dispatch] = useReducer(ClaimsReducer, initialState);

    const { authenticatedState } = useContext(AuthenticationContext);

    const getClaims = (nextPage, prevPage) => {
        dispatch({ type: 'GET_CLAIMS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaims(nextPage, prevPage);
        } else {
            getClaimsPerCountry(nextPage, prevPage, authenticatedState.user.pais);
        }
    };

    const getGlobalClaims = (nextPage, prevPage) => {
        let db = firestoreInitialize();

        if (nextPage) {
            let first = db.collection("Reclamos")
                .orderBy('id')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Reclamos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Reclamos")
                .orderBy('id')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Reclamos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        } else {
            let first = db.collection("Reclamos")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Reclamos")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        }
    };

    const getClaimsPerCountry = (nextPage, prevPage, country) => {
        let db = firestoreInitialize();

        if (nextPage) {
            db.collection("Reclamos")
                .where('id', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Reclamos")
                    .where('pais', '==', country)
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Reclamos")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Reclamos")
                .where('id', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {
                    let first = db.collection("Reclamos")
                    .where('pais', '==', country)
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Reclamos")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        } else {
            let first = db.collection("Reclamos")
                .where('pais', '==', country)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Reclamos")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_CLAIMS', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
        }
    };

    const getClaimsExcel = () => {
        dispatch({ type: 'GET_CLAIMS_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaimsExcel();
        } else {
            getClaimsPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalClaimsExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos")

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_CLAIMS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_CLAIMS_EXCEL_ERROR', payload: { code: 'claims/error', message: error } }))   
    };

    const getClaimsPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos")
            .where('pais', "==", country)

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_CLAIMS_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_CLAIMS_EXCEL_ERROR', payload: { code: 'claims/error', message: error } }))   
    }

    const getClaimsNotApproved = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_CLAIMS_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaimsNotApproved(nextPage, prevPage, notPagination);
        } else {
            getClaimsNotApprovedPerCountry(nextPage, prevPage, notPagination, authenticatedState.user.pais);
        }
    };

    const getGlobalClaimsNotApproved = (nextPage, prevPage, notPagination) => {
        let db = firestoreInitialize();

        if (notPagination) {
            db.collection('Reclamos')
            .where("status", "==", "Abierto")
                .get()
                .then((querySnapshot) => {
                    dispatch({ type: 'GET_CLAIMS', payload: { data: querySnapshot.docs.map(doc => doc.data()), first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1]} });
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
        } else {
            if (nextPage) {
                db.collection('Reclamos')
                .where('id', '==', nextPage)
                .get()
                .then((querySnapshot) => {
                    const dataAfter = querySnapshot.docs[0];
    
                    let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .startAfter(dataAfter)
                    .limit(10)
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
            } else if (prevPage) {
                db.collection('Reclamos')
                .where('id', '==', prevPage)
                .get()
                .then((querySnapshot) => {
                    const dataBefore = querySnapshot.docs[0];
    
                    let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .orderBy("status")
                    .endBefore(dataBefore)
                    .limitToLast(10);
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
            } else {
                let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
            }
        }
    };

    const getClaimsNotApprovedPerCountry = (nextPage, prevPage, notPagination, country) => {
        let db = firestoreInitialize();

        if (notPagination) {
            db.collection('Reclamos')
            .where("status", "==", "Abierto")
            .where("pais", "==", country)
                .get()
                .then((querySnapshot) => {
                    dispatch({ type: 'GET_CLAIMS', payload: { data: querySnapshot.docs.map(doc => doc.data()), first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1]} });
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
        } else {
            if (nextPage) {
                db.collection('Reclamos')
                .where('id', '==', nextPage)
                .get()
                .then((querySnapshot) => {
                    const dataAfter = querySnapshot.docs[0];
    
                    let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .where("pais", "==", country)
                    .startAfter(dataAfter)
                    .limit(10)
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
            } else if (prevPage) {
                db.collection('Reclamos')
                .where('id', '==', prevPage)
                .get()
                .then((querySnapshot) => {
                    const dataBefore = querySnapshot.docs[0];
    
                    let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .where("pais", "==", country)
                    .orderBy("status")
                    .endBefore(dataBefore)
                    .limitToLast(10);
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
                })
                .catch((error) => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))
            } else {
                let first = db.collection("Reclamos")
                    .where("status", "==", "Abierto")
                    .where("pais", "==", country)
                    .limit(10)
    
                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_CLAIMS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_CLAIMS_ERROR', payload: { code: 'claims/error', message: error } }))   
            }
        }
    };

    const getClaimsAllMonth = (country) => {
        dispatch({ type: 'GET_CLAIMS_ALL_MONTH_LOADING' });

        if (country) {
            getClaimsAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaimsAllMonth();
        } else {
            getClaimsAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalClaimsAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let claimsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Reclamos')
            .where('fechaReclamo', '>=', new Date(startDate))
            .where('fechaReclamo', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                claimsPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_CLAIMS_ALL_MONTH', payload: { data: claimsPerMonth } });
    }

    const getClaimsAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let claimsPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Reclamos')
            .where('fechaReclamo', '>=', new Date(startDate))
            .where('fechaReclamo', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                claimsPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_CLAIMS_ALL_MONTH', payload: { data: claimsPerMonth } });
    }

    const getClaimsFilter = (country, page) => {
        dispatch({ type: 'GET_CLAIMS_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaimsFilter(country, page);
        } else {
            getClaimsFilterPerCountry(page, authenticatedState.user.pais);
        }
    }

    const getGlobalClaimsFilter = (country, page) => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos")

        first.get().then((documentSnapshots) => {
            let claims = documentSnapshots.docs.map(doc => doc.data())
            let nextPage;

            if (country) {
                claims = claims.filter(claim => claim.pais === country)
            }

            let nextClaims;

            if (page === '1') {
                nextClaims = claims.slice(10, 11);

                if (nextClaims.length === 1) {
                    nextClaims = true;
                } else {
                    nextClaims = false;
                }

                claims = claims.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextClaims = claims.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextClaims.length === 1) {
                    nextClaims = true;
                } else {
                    nextClaims = false;
                }

                claims = claims.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CLAIMS_FILTER', payload: { data: claims, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextClaims } })
        })
        .catch(error => dispatch({ type: 'GET_CLAIMS_FILTER_ERROR', payload: { code: 'claims/error', message: error } }))     
    }

    const getClaimsFilterPerCountry = (status, type, page, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos").where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false && dataFetch.fechaCierre);
                } else {
                    newData = dataFetch.filter(dataFetch => dataFetch.fechaCierre !== null && !dataFetch.fechaCierre);
                }

                if (type) {
                    newData = newData.filter(dataType => dataType.tipoAliado === type)
                }
            } else {
                newData = dataFetch.filter(dataFetch => dataFetch.tipoAliado === type);
            }

            let nextClaims;

            if (page === '1') {
                nextClaims = newData.slice(10, 11);

                if (nextClaims.length === 1) {
                    nextClaims = true;
                } else {
                    nextClaims = false;
                }

                newData = newData.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextPage = `${page}0`;

                nextClaims = newData.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextClaims.length === 1) {
                    nextClaims = true;
                } else {
                    nextClaims = false;
                }

                newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_CLAIMS_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextClaims } })
        })
        .catch(error => dispatch({ type: 'GET_CLAIMS_FILTER_ERROR', payload: { code: 'claims/error', message: error } }))     
    }

    const getClaimsFilterExcel = (country) => {
        dispatch({ type: 'GET_CLAIMS_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalClaimsFilterExcel(country);
        } else {
            getClaimsFilterPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalClaimsFilterExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos")

        first.get().then((documentSnapshots) => {
            let claims = documentSnapshots.docs.map(doc => doc.data())

            if (country) {
                claims = claims.filter(claim => claim.pais === country)
            }

            dispatch({ type: 'GET_CLAIMS_FILTER_EXCEL', payload: { data: claims, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CLAIMS_FILTER_EXCEL_ERROR', payload: { code: 'claims/error', message: error } }))     
    };

    const getClaimsFilterPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Reclamos")
            .where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            dispatch({ type: 'GET_CLAIMS_FILTER_EXCEL', payload: { data: dataFetch, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_CLAIMS_FILTER_EXCEL_ERROR', payload: { code: 'claims/error', message: error } }))     
    }

    const getClaimsById = (id) => {
        dispatch({ type: 'GET_CLAIMS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Reclamos").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_CLAIMS_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_CLAIMS_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_CLAIMS_BY_ID_ERROR', payload: { code: 'claim/claim-error', message: error } })
        });
    };

    const updateClaimsById = (id, toStatus, data) => {
        dispatch({ type: 'UPDATE_CLAIMS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Reclamos").doc(id);

        switch (toStatus) {
            case 0:
                docRef.update({
                    status: data.status,
                    usuarioAtendio: data.userAttends
                })
                .then(() => {
                    dispatch({ type: 'UPDATE_CLAIMS_BY_ID', payload: { 
                        newAction: data.action,
                        newDateClosed: null,
                        newSolution: data.solution,
                        newStatus: data.status,
                        newUserAttends: data.userAttends,
                        newType: toStatus
                    }});
                })
                .catch((error) => {
                    dispatch({ type: 'UPDATE_CLAIMS_BY_ID_ERROR', payload: { code: 'claim/update-error', message: error } });
                });
                break;
            case 1:
                let date = firebase.firestore.FieldValue.serverTimestamp();
                
                docRef.update({
                    accion: data.action,
                    status: data.status,
                    fechaCierre: date,
                    solucion: data.solution
                })
                .then(() => {
                    dispatch({ type: 'UPDATE_CLAIMS_BY_ID', payload: { 
                        newAction: data.action,
                        newSolution: data.solution,
                        newStatus: data.status,
                        newUserAttends: data.userAttends,
                        newType: toStatus
                    }});
                })
                .catch((error) => {
                    dispatch({ type: 'UPDATE_CLAIMS_BY_ID_ERROR', payload: { code: 'claim/update-error', message: error } });
                });
                break;
        
            default:
                break;
        };
    };

    const getActionsClaims = () => {
        dispatch({ type: 'GET_ACTIONS_CLAIMS_LOADING' });

        let db = firestoreInitialize();

        db.collection("AccionesReclamos").get()
            .then((querySnapshot) => dispatch({ type: 'GET_ACTIONS_CLAIMS', payload: querySnapshot.docs.map(doc => doc.id)}))
            .catch(error => dispatch({ type: 'GET_ACTIONS_CLAIMS_ERROR', payload: { code: 'claims-actions/error', message: error } }))
    };

    const resetClaimsState = () => {
        dispatch({ type: 'CLAIMS_RESET_STATE' });
    };

    const resetClaimsExcelState = () => {
        dispatch({ type: 'CLAIMS_EXCEL_RESET_STATE' });
    };

    return (
        <ClaimsContext.Provider value={{
            claimsState: state.getClaims,
            claimsAllMonthState: state.getClaimsAllMonth,
            claimByIdState: state.getClaimsById,
            actionsClaimsState: state.getActionsClaims,
            claimUpdateState: state.updateClaimsById,
            claimsExcelState: state.getClaimsExcel,
            getClaims,
            getClaimsExcel,
            getClaimsFilterExcel,
            getClaimsNotApproved,
            getClaimsById,
            getClaimsAllMonth,
            getActionsClaims,
            getClaimsFilter,
            updateClaimsById,
            resetClaimsState,
            resetClaimsExcelState
        }}>
            {props.children}
        </ClaimsContext.Provider>
    )
}

export default ClaimsState;
